<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button class="pill next-pill-button" @click="save('userForm')" :disabled="formsData.userForm.disabled">
          <span>Save</span>
        </ion-button>
      </ion-buttons>
      <ion-title>My Profile</ion-title>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <el-form :model="formsData?.userForm" :rules="formsData?.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')"
          @keyup.enter="goNext('userForm')">
          <div class="settings_menu">
            <div class="menu_title">
              <span v-if="userRole == 'locum' || userRole === 'agency'">Personal Details</span>
              <span v-else>Business details</span>
            </div>
          </div>
          <!-- WORKING -->
          <div class="form_part">
            <template v-if="userRole == 'pharmacy'">
              <el-form-item label="Pharmacy Name" prop="name">
                <el-input v-model="formsData.userForm.name.value" autocomplete="off" placeholder="Pharmacy Name"
                  :maxlength="75" @keyup="formsData.userForm.name.value = $event.target.value"
                  @input="checkFormValidation('userForm', true)"></el-input>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item :label="formLabel" prop="firstName">
                <el-input v-model="formsData.userForm.firstName.value" autocomplete="off" placeholder="Given Name"
                  :maxlength="20" @input="checkFormValidation('userForm', true)" @keyup="
                    formsData.userForm.firstName.value = $event.target.value
                  "></el-input>
              </el-form-item>
              <el-form-item label="Family Name" v-if="userRole !== 'agency' || !userData.isAgencyManager"
                prop="lastName">
                <el-input v-model="formsData.userForm.lastName.value" autocomplete="off" placeholder="Family Name"
                  :maxlength="20" @input="checkFormValidation('userForm', true)"
                  @keyup="formsData.userForm.lastName.value = $event.target.value"></el-input>
              </el-form-item>
              <el-form-item v-if="userRole !== 'agency'" label="Preferred Name" prop="preferredName">
                <el-input v-model="formsData.userForm.preferredName.value" autocomplete="off"
                  placeholder="Preferred Name" :maxlength="20" @input="checkFormValidation('userForm', true)" @keyup="
                    formsData.userForm.preferredName.value = $event.target.value
                  "></el-input>
              </el-form-item>
            </template>
            <el-form-item label="Find Your Address" prop="address">
              <div class="el-input el-input--suffix">
                <vue-google-autocomplete id="map" classname="el-input__inner"
                  :ref="(el) => (formsData.userForm.address.ref = el)" v-model="formsData.userForm.address.value.text"
                  placeholder="Find your address" @placechanged="setAddressData"
                  @input="checkFormValidation('userForm', true)" @keyup="setAddress" :country="countryArray">
                </vue-google-autocomplete>
                <span class="el-input__suffix">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.9999 11.1912C11.4358 11.1912 12.5999 10.0272 12.5999 8.59121C12.5999 7.15527 11.4358 5.99121 9.9999 5.99121C8.56396 5.99121 7.3999 7.15527 7.3999 8.59121C7.3999 10.0272 8.56396 11.1912 9.9999 11.1912Z"
                      stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
                    <path
                      d="M3.01675 7.07533C4.65842 -0.141339 15.3501 -0.133006 16.9834 7.08366C17.9418 11.317 15.3084 14.9003 13.0001 17.117C11.3251 18.7337 8.67508 18.7337 6.99175 17.117C4.69175 14.9003 2.05842 11.3087 3.01675 7.07533Z"
                      stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
                  </svg>
                </span>
              </div>
            </el-form-item>
            <el-form-item v-if="userRole == 'pharmacy'" label="Shop Number" prop="shop_number">
              <el-input @keyup="
                  formsData.userForm.shop_number.value = $event.target.value
                " :ref="(el) => (formsData.userForm.shop_number.ref = el)"
                v-model="formsData.userForm.shop_number.value" placeholder="Shop number">
              </el-input>
            </el-form-item>
          </div>
          <!-- WORKING -->
          <div class="form_part">
            <el-form-item label="Phone Number" prop="mobileNumber" :required="true"
              class="collapsing-dropdown-scroll-off">
              <div class="el-input">
                <vue-tel-input class="el-input__inner" :value="formsData.userForm.mobileNumber.valueFormatted"
                  v-model="formsData.userForm.mobileNumber.value" @input="onPhoneInput"
                  :preferredCountries="[$filters.vueTelInput()]" :autoDefaultCountry="false"
                  v-bind="{ mode: 'international' }"></vue-tel-input>
              </div>
            </el-form-item>
            <el-form-item :required="true" v-if="userRole == 'pharmacy'" label="Australian Business Number" prop="abn">
              <input type="tel" class="el-input el-input__inner" :ref="(el) => (formsData.userForm.abn.ref = el)"
                :value="formsData.userForm.abn.value" :placeholder="'00 000 000 000'"
                v-imask="formsData.userForm.abn.mask" @accept="onFormMaskAccept($event, 'userForm', 'abn')"
                @blur="checkFormValidation('userForm', true, 'abn')" />
            </el-form-item>
            <el-form-item label="Email" prop="email" :required="true">
              <el-input type="email" v-model="formsData.userForm.email.value" placeholder="email@gmail.com"
                @input="checkFormValidation('userForm', true)"></el-input>
            </el-form-item>
            <el-form-item v-if="userRole === 'pharmacy'" label="Find your address" prop="billing_address">
              <div class="el-input el-input--suffix">
                <vue-google-autocomplete id="billing_address_input" classname="el-input__inner"
                  :ref="(el) => (formsData.userForm.billing_address.ref = el)"
                  v-model="formsData.userForm.billing_address.value" :value="formsData.userForm.billing_address.value"
                  placeholder="Find your address" @placechanged="setBillingAddress" :country="countryArray">
                </vue-google-autocomplete>
                <span class="el-input__suffix">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.9999 11.1912C11.4358 11.1912 12.5999 10.0272 12.5999 8.59121C12.5999 7.15527 11.4358 5.99121 9.9999 5.99121C8.56396 5.99121 7.3999 7.15527 7.3999 8.59121C7.3999 10.0272 8.56396 11.1912 9.9999 11.1912Z"
                      stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
                    <path
                      d="M3.01675 7.07533C4.65842 -0.141339 15.3501 -0.133006 16.9834 7.08366C17.9418 11.317 15.3084 14.9003 13.0001 17.117C11.3251 18.7337 8.67508 18.7337 6.99175 17.117C4.69175 14.9003 2.05842 11.3087 3.01675 7.07533Z"
                      stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
                  </svg>
                </span>
              </div>
            </el-form-item>
            <el-form-item v-if="userRole == 'pharmacy'" label="Billing Email" prop="billing_email" :required="true">
              <el-input type="email" @keyup="
                  formsData.userForm.billing_email.value = $event.target.value
                " v-model="formsData.userForm.billing_email.value"
                :ref="(el) => (formsData.userForm.billing_email.ref = el)" placeholder="billing-email@gmail.com"
                @input="checkFormValidation('userForm', true)"></el-input>
            </el-form-item>
            <el-form-item v-if="userRole == 'pharmacy'" label="Additional Billing Email" prop="billing_email2">
              <el-input type="email" @keyup="
                  formsData.userForm.billing_email2.value = $event.target.value
                " v-model="formsData.userForm.billing_email2.value"
                :ref="(el) => (formsData.userForm.billing_email2.ref = el)" placeholder="billing-email@gmail.com"
                @input="checkFormValidation('userForm', true)"></el-input>
            </el-form-item>
            <el-form-item v-if="userData.isInternalLocum === true" label="Show Marketplace Shifts" prop="show_marketplace_shifts_tab">
              <el-checkbox v-model="formsData.userForm.show_marketplace_shifts_tab.value" @change="checkFormValidation('userForm', true)">
                Show Marketplace Shifts
              </el-checkbox>
            </el-form-item>
          </div>
          <template v-if="userRole == 'locum' || userRole === 'agency'">
            <div class="form_part" v-if="userRole !== 'agency'">
              <div class="settings_menu">
                <div class="menu_title">Emergency Contact</div>
              </div>
              <el-form-item label="Emergency Name" prop="emergency_first_name" style="margin-top: 1rem">
                <el-input v-model="formsData.userForm.emergency_first_name.value" autocomplete="off"
                  placeholder="Given Name" :maxlength="50" @keyup="
                    formsData.userForm.emergency_first_name.value =
                      $event.target.value
                  " @input="checkFormValidation('userForm', true)"></el-input>
              </el-form-item>
              <el-form-item label="Emergency Last Name" prop="emergency_last_name" style="margin-top: 1rem">
                <el-input v-model="formsData.userForm.emergency_last_name.value" autocomplete="off"
                  placeholder="Given Last Name" :maxlength="50" @keyup="
                    formsData.userForm.emergency_last_name.value =
                      $event.target.value
                  " @input="checkFormValidation('userForm', true)"></el-input>
              </el-form-item>
              <el-form-item label="Emergency Phone" prop="emergency_phone" :required="true"
                class="collapsing-dropdown-scroll-off">
                <div class="el-input">
                  <vue-tel-input class="el-input__inner" :value="formsData.userForm.emergency_phone.valueFormatted"
                    v-model="formsData.userForm.emergency_phone.value" @input="onPhoneInput3"
                    :preferredCountries="[$filters.vueTelInput()]" :autoDefaultCountry="false"
                    v-bind="{ mode: 'international' }" @blur="
                      checkFormValidation(
                        'userForm',
                        true,
                        'emergencyMobileNumber'
                      )
                    "></vue-tel-input>
                </div>
              </el-form-item>
            </div>
            <div
              id="payout-details-abn"
              class="form_part"
              v-if="(userRole !== 'agency' || userData.isAgencyManager) && isAustralia"
            >

              <div class="settings_menu" v-if="!userData.isAgencyManager || userRole !== 'agency'">
                <div class="menu_title">Payout Details</div>
              </div>
              <el-form-item label="Business Name" prop="businessName" :required="true"
                v-if="(userRole === 'locum' || userRole === 'agency') && isAustralia" style="margin-top: 1rem">
                <el-input v-model="formsData.userForm.businessName.value" :placeholder="'Business Name'"
                  @change="checkFormValidation('userForm', false, 'businessName')"
                  @blur="checkFormValidation('userForm', true, 'businessName')"
                  @input="checkFormValidation('userForm', true)" @keyup="
                    formsData.userForm.businessName.value = $event.target.value
                  "></el-input>
              </el-form-item>
              <el-form-item label="Australian Business Number" prop="abn" :required="true" style="margin-top: 1rem"
                v-if="isAustralia">
                <div class="el-input">

                  <input type="tel" class="el-input__inner" :ref="(el) => (formsData.userForm.abn.ref = el)"
                    :value="formsData.userForm.abn.value" :placeholder="'00 000 000 000'"
                    v-imask="formsData.userForm.abn.mask" @accept="onFormMaskAccept($event, 'userForm', 'abn')"
                    @blur="checkFormValidation('userForm', true)" />
                </div>
              </el-form-item>
              <template v-if="isAustralia">
                <div class="form_text text-center" v-if="!userData.isAgencyManager || userRole !== 'agency'">
                  <div class="text_note">
                    Dont have ABN ?
                    <a href=" https://www.abr.gov.au/business-super-funds-charities/applying-abn " target="_blank">Sign
                      up
                      here</a>
                  </div>
                </div>
              </template>

            </div>
            <div class="form_part" v-if="userRole === 'locum' && isAustralia">
              <div class="settings_menu" id="modify_AHPRA">
                <div class="menu_title">AHPRA Verification</div>
              </div>
              <el-form-item label="AHPRA Registration number" prop="ahpraNumber" :required="true"
                style="margin-top: 1rem">
                <div class="el-input">

                  <input class="el-input__inner" :ref="(el) => (formsData.userForm.ahpraNumber.ref = el)"
                    :value="formsData.userForm.ahpraNumber.value" :placeholder="'AAA 000000000'"
                    v-imask="formsData.userForm.ahpraNumber.mask"
                    @accept="onFormMaskAccept($event, 'userForm', 'ahpraNumber')"
                    @blur="checkFormValidation('userForm', true, 'ahpraNumber')" />
                </div>
              </el-form-item>
              <el-form-item label="Expiration Date" prop="ahpraExpiryDate" :required="true">
                <el-date-picker popper-class="datepicker_popper drawer-style"
                  v-model="formsData.userForm.ahpraExpiryDate.valueFormatted" type="date" placeholder="DD/MM/YYYY"
                  :format="$filters.systemDateFormat()" @change="dateConvert"
                  @input="checkFormValidation('userForm', true)">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="form_part" v-if="!userData.isAgencyManager || userRole !== 'agency'">
              <div class="settings_menu">
                <div class="settings_menu">
                  <div class="menu_title">Job board</div>
                </div>
                <el-button type="transparent" class="menu_item" @click="links.changeJobSeekerAdditional">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M10.75 2.44995C11.45 1.85995 12.58 1.85995 13.26 2.44995L14.84 3.79995C15.14 4.04995 15.71 4.25995 16.11 4.25995H17.81C18.87 4.25995 19.74 5.12995 19.74 6.18995V7.88995C19.74 8.28995 19.95 8.84995 20.2 9.14995L21.55 10.7299C22.14 11.4299 22.14 12.5599 21.55 13.2399L20.2 14.8199C19.95 15.1199 19.74 15.6799 19.74 16.0799V17.7799C19.74 18.8399 18.87 19.7099 17.81 19.7099H16.11C15.71 19.7099 15.15 19.9199 14.85 20.1699L13.27 21.5199C12.57 22.1099 11.44 22.1099 10.76 21.5199L9.18001 20.1699C8.88001 19.9199 8.31 19.7099 7.92 19.7099H6.17C5.11 19.7099 4.24 18.8399 4.24 17.7799V16.0699C4.24 15.6799 4.04 15.1099 3.79 14.8199L2.44 13.2299C1.86 12.5399 1.86 11.4199 2.44 10.7299L3.79 9.13995C4.04 8.83995 4.24 8.27995 4.24 7.88995V6.19995C4.24 5.13995 5.11 4.26995 6.17 4.26995H7.9C8.3 4.26995 8.86 4.05995 9.16 3.80995L10.75 2.44995Z"
                      stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M12 8.13V12.96" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M11.9945 16H12.0035" stroke="rgb(var(--locumate-primary-color))" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <div class="text_wrapper">
                    <div class="main_text">Additional Information</div>
                  </div>
                </el-button>
              </div>
            </div>

            <div class="form_part"></div>
            <div class="settings_menu">
              <div class="settings_menu">
                <div class="menu_title">Settings</div>
              </div>
              <el-button type="transparent" class="menu_item" @click="links.goToGst" v-if="userRole !== 'agency'">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22 6V8.42C22 10 21 11 19.42 11H16V4.01C16 2.9 16.91 2 18.02 2C19.11 2.01 20.11 2.45 20.83 3.17C21.55 3.9 22 4.9 22 6Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M2 7V21C2 21.83 2.94 22.3 3.6 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.29 22.29C8.68 22.68 9.32 22.68 9.71 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7H6C3 2 2 3.79 2 6V7Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.27002 13.73L11.73 8.27002" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.9247 13.5H11.9337" stroke="rgb(var(--locumate-primary-color))" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.1947 8.5H6.20368" stroke="rgb(var(--locumate-primary-color))" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                <div class="text_wrapper">
                  <div class="main_text">GST</div>
                </div>
              </el-button>
              <el-button type="transparent" class="menu_item" @click="links.preferences"
                v-if="userRole !== 'agency' && userRole == 'locum' && isAustralia">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M1.66663 10.7334V9.2667C1.66663 8.40003 2.37496 7.68336 3.24996 7.68336C4.75829 7.68336 5.37496 6.6167 4.61663 5.30836C4.18329 4.55836 4.44163 3.58336 5.19996 3.15003L6.64163 2.32503C7.29996 1.93336 8.14996 2.1667 8.54163 2.82503L8.63329 2.98336C9.38329 4.2917 10.6166 4.2917 11.375 2.98336L11.4666 2.82503C11.8583 2.1667 12.7083 1.93336 13.3666 2.32503L14.8083 3.15003C15.5666 3.58336 15.825 4.55836 15.3916 5.30836C14.6333 6.6167 15.25 7.68336 16.7583 7.68336C17.625 7.68336 18.3416 8.3917 18.3416 9.2667V10.7334C18.3416 11.6 17.6333 12.3167 16.7583 12.3167C15.25 12.3167 14.6333 13.3834 15.3916 14.6917C15.825 15.45 15.5666 16.4167 14.8083 16.85L13.3666 17.675C12.7083 18.0667 11.8583 17.8334 11.4666 17.175L11.375 17.0167C10.625 15.7084 9.39163 15.7084 8.63329 17.0167L8.54163 17.175C8.14996 17.8334 7.29996 18.0667 6.64163 17.675L5.19996 16.85C4.44163 16.4167 4.18329 15.4417 4.61663 14.6917C5.37496 13.3834 4.75829 12.3167 3.24996 12.3167C2.37496 12.3167 1.66663 11.6 1.66663 10.7334Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                <div class="text_wrapper">
                  <div class="main_text">Work Preferences</div>
                </div>
              </el-button>
              <el-button type="transparent" class="menu_item" @click="links.softwareExperience"
                v-if="userRole !== 'agency' && userRole == 'locum'">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.89001 9C7.87001 9.49 8.71001 10.23 9.32001 11.15C9.67001 11.67 9.67001 12.34 9.32001 12.86C8.71001 13.77 7.87001 14.51 6.89001 15"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M13 15H17" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <div class="text_wrapper">
                  <div class="main_text">Pharmacy Management Software</div>
                </div>
              </el-button>
              <el-button type="transparent" class="menu_item" @click="links.pharmacyExperience"
                v-if="userRole !== 'agency' && userRole == 'locum'">
                <!-- <i class="locumate_icons el-icon-pie-chart"></i> -->
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19 9C19 10.45 18.57 11.78 17.83 12.89C16.75 14.49 15.04 15.62 13.05 15.91C12.71 15.97 12.36 16 12 16C11.64 16 11.29 15.97 10.95 15.91C8.96 15.62 7.25 14.49 6.17 12.89C5.43 11.78 5 10.45 5 9C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M21.25 18.47L19.6 18.86C19.23 18.95 18.94 19.23 18.86 19.6L18.51 21.07C18.32 21.87 17.3 22.11 16.77 21.48L12 16L7.22996 21.49C6.69996 22.12 5.67996 21.88 5.48996 21.08L5.13996 19.61C5.04996 19.24 4.75996 18.95 4.39996 18.87L2.74996 18.48C1.98996 18.3 1.71996 17.35 2.26996 16.8L6.16996 12.9C7.24996 14.5 8.95996 15.63 10.95 15.92C11.29 15.98 11.64 16.01 12 16.01C12.36 16.01 12.71 15.98 13.05 15.92C15.04 15.63 16.75 14.5 17.83 12.9L21.73 16.8C22.28 17.34 22.01 18.29 21.25 18.47Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M12.58 5.98L13.17 7.15999C13.25 7.31999 13.46 7.48 13.65 7.51L14.72 7.68999C15.4 7.79999 15.56 8.3 15.07 8.79L14.24 9.61998C14.1 9.75998 14.02 10.03 14.07 10.23L14.31 11.26C14.5 12.07 14.07 12.39 13.35 11.96L12.35 11.37C12.17 11.26 11.87 11.26 11.69 11.37L10.69 11.96C9.96997 12.38 9.53997 12.07 9.72997 11.26L9.96997 10.23C10.01 10.04 9.93997 9.75998 9.79997 9.61998L8.96997 8.79C8.47997 8.3 8.63997 7.80999 9.31997 7.68999L10.39 7.51C10.57 7.48 10.78 7.31999 10.86 7.15999L11.45 5.98C11.74 5.34 12.26 5.34 12.58 5.98Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>



                <div class="text_wrapper">
                  <div class="main_text">Advanced Credentials</div>
                </div>
              </el-button>
              <el-button type="transparent" class="menu_item" @click="links.travel" v-if="userRole !== 'agency'">
                <i class="el-icon-position locumate-primary-color"></i>
                <div class="text_wrapper">
                  <div class="main_text">Travel Requirements</div>
                </div>
              </el-button>
              <el-button type="transparent" class="menu_item" @click="links.languages" v-if="userRole !== 'agency'">
                <i class="el-icon-chat-line-round locumate-primary-color"></i>
                <div class="text_wrapper">
                  <div class="main_text">Languages</div>
                </div>
              </el-button>
              <el-button type="transparent" class="menu_item" @click="links.changePassword">
                <i class="el-icon-set-up locumate-primary-color"></i>
                <div class="text_wrapper">
                  <div class="main_text">Password Change</div>
                </div>
              </el-button>
              <el-button type="transparent" class="menu_item" @click="links.accountDeletionRequest">
                <span class="locumate_icons locumate_icon-warning"></span>
                <div class="text_wrapper">
                  <div class="main_text">Request Account Deletion</div>
                </div>
              </el-button>
            </div>
            <div class="profile_confirmed" v-if="
                isAustralia &&
                userData.active &&
                userRole === 'locum' &&
                userData.ahpra.number != null
              ">
              <span class="text">Confirmed by AHPRA</span>
              <span class="locumate_icons locumate_icon-check"></span>
            </div>
          </template>
          <!-- !!!!!!!!  -->
          <!-- PHARMACY -->
          <template v-else>
            <div class="settings_menu">
              <div class="menu_title">Additional Contacts</div>
            </div>
            <div class="form_part">
              <el-form-item label="Primary Contact" prop="additionalName1">
                <el-input v-model="formsData.userForm.additionalName1.value" autocomplete="off" placeholder="Given Name"
                  :maxlength="20" @keyup="
                    formsData.userForm.additionalName1.value = $event.target.value
                  "></el-input>
              </el-form-item>
              <el-form-item label="Primary Contact’s Phone Number " prop="additionalPhone1">
                <div class="el-input">
                  <vue-tel-input class="el-input__inner" :value="formsData.userForm.additionalPhone1.valueFormatted"
                    v-model="formsData.userForm.additionalPhone1.value" :preferredCountries="[$filters.vueTelInput()]"
                    :autoDefaultCountry="false" v-bind="{ mode: 'international' }"
                    @input="onPhoneInput1"></vue-tel-input>
                </div>
              </el-form-item>
            </div>
            <div class="form_part">
              <el-form-item label="Secondary Contact" prop="additionalName2">
                <el-input v-model="formsData.userForm.additionalName2.value" autocomplete="off" placeholder="Given Name"
                  :maxlength="20" @keyup="
                    formsData.userForm.additionalName2.value = $event.target.value
                  "></el-input>
              </el-form-item>
              <el-form-item label="Secondary Contact's Phone Number" prop="additionalPhone2">
                <div class="el-input">
                  <vue-tel-input class="el-input__inner" :value="formsData.userForm.additionalPhone2.valueFormatted"
                    v-model="formsData.userForm.additionalPhone2.value" :preferredCountries="[$filters.vueTelInput()]"
                    :autoDefaultCountry="false" v-bind="{ mode: 'international' }"
                    @input="onPhoneInput2"></vue-tel-input>
                </div>
              </el-form-item>
            </div>
            <div class="settings_menu" id="update_script">
              <div class="el-form-item__label mt-3">Average scripts per day (weekdays)</div>
            </div>
            <div class="scripts with_scroll">
              <el-form-item prop="scripts">
                <el-select v-model="formsData.userForm.scripts.value" ref="averageScriptsRef"
                  placeholder="Select an option" popper-class="drawer-style avg-scripts" :destroy-on-close="true">
                  <div class="auth-header">
                    <div class="auth-heading">
                      <h1>Select</h1>
                    </div>
                  </div>
                  <button class="icon-button close-button" @click.prevent="closeOption('averageScriptsRef')">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                        fill="black" />
                    </svg>
                  </button>
                  <el-option v-for="fieldData in formsData.userForm.scripts.data" :key="fieldData.id"
                    :label="fieldData.name" :value="fieldData.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="subform scripts with_scroll">
              <div class="el-form-item__label">Average scripts on Saturday</div>
              <el-form-item prop="average_scripts_saturday_id">
                <el-select v-model="formsData.userForm.average_scripts_saturday_id.value" placeholder="Select an option"
                  ref="saturdayScriptsRef" popper-class="drawer-style  avg-scripts">
                  <div class="auth-header">
                    <div class="auth-heading">
                      <h1>Select</h1>
                    </div>
                  </div>
                  <button class="icon-button close-button" @click.prevent="closeOption('saturdayScriptsRef')">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                        fill="black" />
                    </svg>
                  </button>
                  <el-option v-for="fieldData in formsData.userForm.scripts.data" :key="fieldData.id"
                    :label="fieldData.name" :value="fieldData.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="subform scripts with_scroll">
              <div class="el-form-item__label">Average scripts on Sunday</div>
              <el-form-item prop="average_scripts_sunday_id">
                <el-select popper-class="drawer-style avg-scripts"
                  v-model="formsData.userForm.average_scripts_sunday_id.value" ref="sundayScriptsRef"
                  placeholder="Select an option">
                  <div class="auth-header">
                    <div class="auth-heading">
                      <h1>Select</h1>
                    </div>
                  </div>
                  <button class="icon-button close-button" @click.prevent="closeOption('sundayScriptsRef')">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                        fill="black" />
                    </svg>
                  </button>
                  <el-option v-for="fieldData in formsData.userForm.scripts.data" :key="fieldData.id"
                    :label="fieldData.name" :value="fieldData.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="settings_menu">
              <div class="el-form-item__label">Dispensing software</div>
            </div>
            <div class="software with_scroll">
              <el-form-item prop="software">
                <el-select v-model="formsData.userForm.software.value" ref="dispensingSoftwareRef"
                  popper-class="drawer-style" placeholder="Select a software" @change="handleSoftwareChange">
                  <div class="auth-header">
                    <div class="auth-heading">
                      <h1>Select</h1>
                    </div>
                  </div>
                  <button class="icon-button close-button" @click.prevent="closeOption('dispensingSoftwareRef')">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                        fill="black" />
                    </svg>
                  </button>
                  <el-option v-for="fieldData in formsData.userForm.software.data" :key="fieldData.id"
                    :label="fieldData.name" :value="fieldData.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="selectedDispensingSoftware === 'Other' || getSelectedSoftwareName() === 'Other'"
                label="Software Other" prop="software_other" :required="true">

                <el-input class="number_input" placeholder="Please provide other software information"
                  v-model="formsData.userForm.software_other.value" @keyup="checkFormValidation('userForm', true)"
                  @input="checkFormValidation('userForm', true)"></el-input>
              </el-form-item>
            </div>
            <div class="settings_menu">
              <div class="el-form-item__label">
                Services
                <span>({{ formsData.userForm.services.value.length }})</span>
              </div>
            </div>
            <div class="services with_scroll">
              <el-form-item prop="services">
                <el-checkbox-group v-model="formsData.userForm.services.value">
                  <el-checkbox-button v-for="fieldData in formsData.userForm.services.data" :key="fieldData.id"
                    :label="fieldData.id">{{ fieldData.name }}
                  </el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <div v-show="isOphioidSelected >= 0">
              <div class="el-form-item__label">Patients Quantity</div>
              <el-form-item prop="number_of_patients">
                <el-input type="number" class="number_input"
                  placeholder="Please select the number of patients on the Opioid substitution program"
                  v-model="formsData.userForm.number_of_patients.value"></el-input>
              </el-form-item>
            </div>

            <template v-if="$filters.employerType(userData).isValid && $filters.employerType(userData).isCommunityPharmacy">
              <div class="settings_menu">
                <div class="menu_title">Additional Information</div>
              </div>
              <div class="form_part">
                <el-form-item label="Robotic Dispensing System" prop="roboticDispensingSystem">
                    <el-select popper-class="normal-select" class="w-100"
                        v-model="formsData.userForm.roboticDispensingSystem.value"
                        placeholder="Select Robotic Dispensing System" @change="handleForm"
                        :popper-append-to-body="true">
                        <el-option v-for="option in pharmacyAdditionalInfo?.communityPharmacyAdditionalInfo[0]?.values || []" :key="option.label" :label="option.label"
                            :value="option.label"></el-option>
                    </el-select>
                </el-form-item>
  
                <el-form-item v-if="formsData.userForm.roboticDispensingSystem.value === 'Others'"
                    label="Other Robotic Dispensing System" prop="hasRoboticDispensingSystem_other" :required="true">
                    <el-input v-model="formsData.userForm.hasRoboticDispensingSystem_other.value"
                        placeholder="Enter Robotic Dispensing System you use"
                        ></el-input>
                </el-form-item>
              </div>
            </template>
            <div class="form_part">
              <div class="settings_menu">
                <div class="menu_title">Settings</div>
              </div>
              <div class="settings_menu">
                <el-button type="transparent" class="menu_item" @click="links.gallery">
                  <img src="@/assets/img/icons/gallery.svg" alt="Gallery">
                  <div class="text_wrapper">
                    <div class="main_text">Gallery</div>
                  </div>
                </el-button>
                <el-button type="transparent" class="menu_item" @click="links.changePassword">
                  <!-- <span class="locumate_icons el-icon-set-up"></span> -->
                  <img src="@/assets/img/icons/key-square.svg" alt="Gallery">
                  <div class="text_wrapper">
                    <div class="main_text">Password Change</div>
                  </div>
                </el-button>
              </div>
            </div>
          </template>
        </el-form>
      </div>

      <div class="bg-overlay"></div>
    </div>
  </div>
</template>

<script>
import {
  onMounted,
  inject,
  defineAsyncComponent,
  nextTick,
  computed,
  ref,
  getCurrentInstance,
  watch
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
// import moment from "moment";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import formMasks from "@/hooks/form/mask/mask";

import IMaskDirective from "@/directives/vue-imask/directive";
import IMask from "imask/esm/imask";

import addressText from "@/helpers/address/address.js";

import { VueGoogleAutocomplete } from "@/components/components";

import { ElMessageBox } from "@/components/Vendor/Element";

import { indexOf } from "lodash";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';


const VueTelInput = defineAsyncComponent(() =>
  import("@/components/Vendor/vue-tel-input/components/vue-tel-input.vue")
);

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,

    VueGoogleAutocomplete,

    VueTelInput,
  },
  directives: {
    imask: IMaskDirective,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const googleMaps = inject(["googleMaps"]);
    const $moment = inject(["$moment"]);
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const email = userData.email;
    const billing_email = userData.billingEmail;
    const billing_email2 = userData.billingEmail2;
    const billing = userData.billing;
    const ahpra = userData.ahpra;
    const workEnvRef = ref(null);
    const dispensingSoftwareRef = ref(null);
    const sundayScriptsRef = ref(null);
    const saturdayScriptsRef = ref(null);
    const averageScriptsRef = ref(null);
    const isAustralia = isAustraliaRegion();
    const countryArray = computed(() => {
            const region = process.env.VUE_APP_REGION;
            if (region === 'US') return ['us'];
            if (region === 'AU') return ['au'];
            return []; // Default or empty if region is not recognized
        });
    const pharmacyAdditionalInfo = $store.getters.pharmacyAdditionalInfo;
    const instance = getCurrentInstance();

    const isOphioidSelected = computed(() => {
      return indexOf(formsData.userForm.services.value, 6);
    });
    const backPage = $store.getters.getLastPage;
  

    const dateConvert = () => {
      if (formsData.userForm.ahpraExpiryDate.valueFormatted) {
        const result = $moment(
          formsData.userForm.ahpraExpiryDate.valueFormatted,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");
        formsData.userForm.ahpraExpiryDate.value = result;
        checkFormValidation("userForm", true);
      } else {
        formsData.userForm.ahpraExpiryDate.value= null;
        return null;
      }
    };

    const ahpraExpiryDateValue = ahpra.date
      ? $moment(ahpra.date, "YYYY-MM-DD").format("YYYY-MM-DD")
      : new Date(new Date().setFullYear(new Date().getFullYear()));

    const formsDataArray = {
      userForm: {
        address: {
          value: {
            text: addressText(userData.address ? userData.address : ""),
            temp: addressText(userData.address ? userData.address : ""),
          },
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "address",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },

        mobileNumber: {
          ref: {},
          value: userData.mobileNumber ? userData.mobileNumber : "",
          valueFormatted: userData.mobileNumber ? userData.mobileNumber : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "mobileNumber",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
          errors: null,
        },
        email: {
          value: email ? email : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "email",
                  callback,
                  setFormValidation
                );
              },
              trigger: ["blur", "enter"],
            },
          ],
        },
        software_other: {
            value: userData.settings.softwareOther ? userData.settings.softwareOther : null,
           
        },
      },
    };
    if (userRole == "locum") {
      // const minRate = userData.minRate;
      // const weekendRate = userData.weekendRate;
      // const schedule = userData.schedule;

      const dataArray = {
        firstName: {
          value: userData?.firstName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "firstName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        lastName: {
          value: userData?.lastName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "lastName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        show_marketplace_shifts_tab: {
          value: userData?.showMarketplaceShiftsTab === true
            || userData?.showMarketplaceShiftsTab === 1
            || userData?.showMarketplaceShiftsTab === "1",
          resetValue: true,
        },
        preferredName: {
          value: userData?.preferredName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "preferredName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        emergency_first_name: {
          value: userData.emergencyContact.firstName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "emergencyFirstName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        emergency_last_name: {
          value: userData.emergencyContact.lastName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "emergencyLastName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        emergency_phone: {
          ref: {},
          value: userData.emergencyContact.mobileNumber || null,
          valueFormatted: userData.emergencyContact.mobileNumber || null,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "emergencyMobileNumber",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
          errors: null,
        },
        businessName: {
          value: billing.businessName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "businessName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        abn: {
          value: userData.abn
            ? IMask.createMask(formMasks.abn).resolve(userData.abn)
            : "",
          // value: $store.getters.getUserData.billing.abn || '14 069 979 460',
          mask: formMasks.abn,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "abn",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        ahpraNumber: {
          value: ahpra.number
            ? IMask.createMask(formMasks.ahpraNumber).resolve(ahpra.number)
            : "",
          mask: formMasks.ahpraNumber,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "ahpra",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },

        ahpraExpiryDate: {
          ref: null,
          value: ahpra.date ? ahpraExpiryDateValue : "",
          valueFormatted: ahpraExpiryDateValue,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  {
                    rule: "ahpraExpiryDate",
                  },
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      };

      Object.assign(formsDataArray.userForm, dataArray);
    }

    if (userRole == "pharmacy") {
      const environment = userData.environment;
      const scripts = $store.getters.GET_PHARMACY_SCRIPTS_COUNT;
      const software = $store.getters.GET_PHARMACY_SOFTWARE;
      const services = $store.getters.GET_PHARMACY_SERVICES;

      const dataArray = {
        name: {
          value: userData.name || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "pharmacyName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        shop_number: {
          value: userData.address.shopNumber || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "shopNumber",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        scripts: {
          data: scripts,
          value: environment.scriptsPerDay,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "environmentScriptsPerDay",
                  callback,
                  setFormValidation
                );
              },
              trigger: "change",
            },
          ],
        },
        average_scripts_saturday_id: {
          data: scripts,
          value: userData.averageScriptsSaturdayId,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "scriptsSaturday",
                  callback,
                  setFormValidation
                );
              },
              trigger: "change",
            },
          ],
        },
        average_scripts_sunday_id: {
          data: scripts,
          value: userData.averageScriptsSundayId,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "scriptsSunday",
                  callback,
                  setFormValidation
                );
              },
              trigger: "change",
            },
          ],
        },
        billing_address: {
          value: userData.billing.address.text,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "billingAddress",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        abn: {
          value: userData.abn
            ? IMask.createMask(formMasks.abn).resolve(userData.abn)
            : "",
          // value: $store.getters.getUserData.billing.abn || '14 069 979 460',
          mask: formMasks.abn,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "abn",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        number_of_patients: {
          value: userData.numberOfPatients ? userData.numberOfPatients : null,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "numberOfPatients",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        software: {
          data: software,
          value: environment.software,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "environmentSoftware",
                  callback,
                  setFormValidation
                );
              },
              trigger: "change",
            },
          ],
        },
        services: {
          data: services,
          value: Object.values(environment.services).map((value) => value.id),
          resetValue: true,
          resetValueSort: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "environmentServices",
                  callback,
                  setFormValidation
                );
              },
              trigger: "change",
            },
          ],
        },
        additionalName1: {
          value: userData.additionalName1 || "",

          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "additionalName1",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        additionalPhone1: {
          ref: {},
          value: userData.additionalPhone1 || null,
          valueFormatted: userData.additionalPhone1 || null,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "additionalPhone1",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
          errors: null,
        },
        additionalName2: {
          value: userData.additionalName2 || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "additionalName1",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        additionalPhone2: {
          ref: {},
          value: userData.additionalPhone2 || null,
          valueFormatted: userData.additionalPhone2 || null,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "additionalPhone2",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
          errors: null,
        },
        billing_email: {
          value: billing_email ? billing_email : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "email",
                  callback,
                  setFormValidation
                );
              },
              trigger: ["blur", "enter"],
            },
          ],
        },
        billing_email2: {
          value: billing_email2 ? billing_email2 : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "additionalEmail",
                  callback,
                  setFormValidation
                );
              },
              trigger: ["blur", "enter"],
            },
          ],
        },
        roboticDispensingSystem: {
          value: userData.customFields?.communityPharmacyAdditionalInfo?.[0]?.value ?? "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "hasRoboticDispensingSystem",
                  callback,
                  setFormValidation
                );
              },
              trigger: "change",
            },
          ]
        },
        hasRoboticDispensingSystem_other: {
          value: userData.customFields?.communityPharmacyAdditionalInfo?.[0]?.otherValue ?? "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "hasRoboticDispensingSystem",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        }
      };

      Object.assign(formsDataArray.userForm, dataArray);
    }

    if (userRole == "agency") {
      console.log("inside agency", userData);
      const dataArray = {
        firstName: {
          value: userData.firstName,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "firstName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        lastName: {
          value: userData.lastName,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "lastName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        preferredName: {
          value: userData?.preferredName,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "preferredName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },

        businessName: {
          value: billing.businessName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "businessName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        abn: {
          value: userData.abn
            ? IMask.createMask(formMasks.abn).resolve(userData.abn)
            : "",
          // value: $store.getters.getUserData.billing.abn || '14 069 979 460',
          mask: formMasks.abn,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "abn",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      };

      Object.assign(formsDataArray.userForm, dataArray);
    }

    const onPhoneInput1 = (value, phoneObject) => {
      console.log("EHERE IS TEH PHONE 1");
      if (!value.target) {
        formsData.userForm.additionalPhone1.ref.phoneObject = phoneObject;
      }
      formsData.userForm.additionalPhone1.valueFormatted = value.target
        ? value.target.value
        : value;
      formsData.userForm.additionalPhone1.value =
        formsData.userForm.additionalPhone1.ref.phoneObject.number || null;

      checkFormValidation("userForm", false, "additionalPhone1");
      checkFormValidation("userForm", true);
    };
    const onPhoneInput2 = (value, phoneObject) => {
      if (!value.target) {
        formsData.userForm.additionalPhone2.ref.phoneObject = phoneObject;
      }
      formsData.userForm.additionalPhone2.valueFormatted = value.target
        ? value.target.value
        : value;
      formsData.userForm.additionalPhone2.value =
        formsData.userForm.additionalPhone2.ref.phoneObject.number || null;

      checkFormValidation("userForm", false, "additionalPhone2");
      checkFormValidation("userForm", true);
    };
    const onPhoneInput3 = (value, phoneObject) => {
      if (!value.target) {
        formsData.userForm.emergency_phone.ref.phoneObject = phoneObject;
      }
      formsData.userForm.emergency_phone.valueFormatted = value.target
        ? value.target.value
        : value;
      formsData.userForm.emergency_phone.value =
        formsData.userForm.emergency_phone.ref.phoneObject.number || null;

      checkFormValidation("userForm", false, "emergency_phone");
    };

    const onPhoneInput = (value, phoneObject) => {
      if (!value.target) {
        formsData.userForm.mobileNumber.ref.phoneObject = phoneObject;
      }
      formsData.userForm.mobileNumber.valueFormatted = value.target
        ? value.target.value
        : value;
      formsData.userForm.mobileNumber.value =
        formsData.userForm.mobileNumber.ref.phoneObject.number || null;

      checkFormValidation("userForm", false, "mobileNumber");
      checkFormValidation("userForm", true);
    };
    const onNameCheckboxChange = () => {
      if (formsData.userForm.weekendRate.disabled) {
        formsData.userForm.weekendRate.valueTemp =
          formsData.userForm.weekendRate.value;
        formsData.userForm.weekendRate.value = formsData.userForm.minRate.value;
        // formsData.userForm.weekendRate.value = userData.minRate;
        formsData.userForm.weekendRate.disabled = true;
      } else {
        formsData.userForm.weekendRate.value =
          formsData.userForm.weekendRate.valueTemp;

        formsData.userForm.businessName.disabled = false;
      }
      // checkFormValidation("userForm", true, "weekendRate");
      checkFormValidation("userForm", true);
    };

    // Define a computed property to determine the label dynamically
    const formLabel = computed(() => {
      if (userRole === "agency" && userData.isAgencyManager) {
        return "Agency Name";
      } else {
        return "Given Name";
      }
    });

    const setAddress = () => {
      if (
        formsData.userForm.address.value.text !=
        formsData.userForm.address.value.temp
      ) {
        formsData.userForm.address.value.text = null;
      }
      checkFormValidation("userForm", true, "address");
      checkFormValidation("userForm", true);
    };
    const setBillingAddress = (event, placeResultData) => {
      formsData.userForm.billing_address.value =
        placeResultData.formatted_address;
      checkFormValidation("userForm", true, "billing_address");
    };

    const getComponent = (components, type) => {
      const comp = components.find(c => c.types.includes(type));
      return comp ? comp.short_name : "";
    };

    const setAddressData = async (addressData, placeResultData) => {
      console.log("🚀 ~ setAddressData ~ placeResultData:", placeResultData)
      console.log("🚀 ~ setAddressData ~ addressData:", addressData)
      try {
        formsData.userForm.address.value.lat = addressData.latitude.toString();
        formsData.userForm.address.value.lng = addressData.longitude.toString();
        formsData.userForm.address.value.subpremise = addressData.subpremise
          ? addressData.subpremise
          : "";
        formsData.userForm.address.value.street =
          (formsData.userForm.address.value.subpremise
            ? formsData.userForm.address.value.subpremise + "/"
            : "") +
          (addressData.street_number ? addressData.street_number + " " : "") +
          addressData.route;

        formsData.userForm.address.value.state =
          addressData.administrative_area_level_1 ||
          getComponent(placeResultData.address_components, "administrative_area_level_1");

        formsData.userForm.address.value.suburb =
          addressData.locality ||
          getComponent(placeResultData.address_components, "locality");

        formsData.userForm.address.value.country =
          addressData.country ||
          getComponent(placeResultData.address_components, "country");

        formsData.userForm.address.value.postcode =
          addressData.postal_code ||
          getComponent(placeResultData.address_components, "postal_code");

        console.log("placeResultData", placeResultData.formatted_address);
        formsData.userForm.address.value.text =
          placeResultData.formatted_address;
        formsData.userForm.address.value.temp =
          placeResultData.formatted_address;
        formsData.userForm.address.ref.update(
          formsData.userForm.address.value.text
        );
        const timezone = await googleMaps.getTimeZone(
          formsData.userForm.address.value.lat +
            "," +
            formsData.userForm.address.value.lng
        );
        formsData.userForm.address.value.timezone = timezone.timeZoneId;
      } catch (error) {
        console.log(error);
      }
      checkFormValidation("userForm", true);
    };

    const closeOption = (refInfo) => {
      if (refInfo == 'workEnvRef') {
        workEnvRef.value.blur();
      } else if (refInfo == 'dispensingSoftwareRef') {
        dispensingSoftwareRef.value.blur();
      } else if (refInfo == 'sundayScriptsRef') {
        sundayScriptsRef.value.blur();
      } else if (refInfo == 'saturdayScriptsRef') {
        saturdayScriptsRef.value.blur();
      } else if (refInfo == 'averageScriptsRef') {
        averageScriptsRef.value.blur();
      }


    }

    const goBack = () => {
      $router.push(backPage);

      if (backPage === '/job-seeker/profile') {
            $router.push({
                name: "profile_photo_job_seeker",
            });
        } else {
           $router.push({
            name: "profile",
          });
        }
    };

    const getFormData = (formName) => {
      const result = Object.fromEntries(
        Object.entries(formsData[formName])
          .map(([k, v]) => [k, v?.value])
          .filter(([k, v]) => v !== undefined) // eslint-disable-line no-unused-vars
      );
      if (result.abn) {
        result.abn = result.abn.replaceAll(" ", "");
      }
      if (result.ahpraNumber) {
        result.ahpraNumber = result.ahpraNumber.replaceAll(" ", "");
        result.ahpraNumber = result.ahpraNumber.replaceAll("_", "");
      }
      return result;
    };

    const save = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        console.log("🚀 ~ formsRefs[formName].value.validate ~ valid:", valid)
        if (valid) {
          return (async () => {
            try {
              if (
                (formsData[formName].firstName &&
                  formsData[formName].firstName.fieldChanged) ||
                (formsData[formName].lastName &&
                  formsData[formName].lastName.fieldChanged)
              ) {
                await ElMessageBox.confirm(
                  `Please note, changes to account details such as Name and AHPRA details will move the status of your account to 'unverified'. Locumate will need to verify your details before you can view and accepts shifts. This process can take up to 24 hours.`,
                  "Are you sure you want to change this?",
                  {
                    distinguishCancelAndClose: true,
                    showConfirmButton: !formsData[formName].disabled,
                    confirmButtonText: "Save Changes",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "el-button--green",
                    cancelButtonClass: "el-button--grey",
                    showClose: formsData[formName].disabled,
                  }
                );
                $store.dispatch("IDENTIFY_USER", {
                  name: formsData[formName].firstName.value,
                });
                console.log("IDENTIFY SUCCESFULLY");
              }
              const data = getFormData(formName);
              const mobileNumber = data.mobileNumber;
              const email = data.email;
              delete data.mobileNumber;
              delete data.email;
              
              // tranform community pharmacy form data
              if (userRole === 'pharmacy' && isAustralia.value && instance?.appContext.config.globalProperties.$filters.employerType(userData).isValid && instance?.appContext.config.globalProperties.$filters.employerType(userData).isCommunityPharmacy) {
                const selectedRds = data.roboticDispensingSystem;
                const otherRds = data.hasRoboticDispensingSystem_other;

                data.customfields = {
                  community_pharmacy_additional_info: [{
                    values: [{
                      value: selectedRds,
                      other_value: otherRds ? otherRds : "",
                    }],
                    key: pharmacyAdditionalInfo?.communityPharmacyAdditionalInfo[0]?.key,
                    field_type: pharmacyAdditionalInfo?.communityPharmacyAdditionalInfo[0]?.fieldType,
                  }]
                };
                delete data.roboticDispensingSystem;
                delete data.hasRoboticDispensingSystem_other;

              }
             

              let requests = [];
              console.log('saveData', data);
              
              requests.push($store.dispatch("SAVE_USER_DATA", data));
              let mobileNumberChanged = false;
              let emailChanged = false;
              console.log("FORM DATA:", formsData[formName]);
              if (
                formsData[formName].mobileNumber &&
                formsData[formName].mobileNumber.fieldChanged
              ) {
                mobileNumberChanged = true;
                requests.push(
                  $store.dispatch("UPDATE_USER_PHONE", {
                    phone: mobileNumber,
                  })
                );
              }

              if (
                formsData[formName].email &&
                formsData[formName].email.fieldChanged
              ) {
                emailChanged = true;
                requests.push($store.dispatch("IDENTIFY_USER", { email }));
                requests.push(
                  $store.dispatch("UPDATE_USER_EMAIL", {
                    email: email,
                  })
                );
              }

              await Promise.all(requests);

              if (mobileNumberChanged) {
                $store.dispatch("setVerifyPageData", {
                  mobileNumber: mobileNumber,
                });
              }

              if (emailChanged) {
                $store.dispatch("setVerifyPageData", {
                  email: email,
                });
              }
              copyFormResetValue("userForm", true);
              goBack();
            } catch (errors) {
              $store.dispatch("clearVerifyPageData", {
                mobileNumber: null,
                email: null,
              });
              for (let key in errors) {
                setFieldError(formName, key, errors[key]);
                // }
                // setFieldError('userForm', 'password', error.message);
              }
              checkFormValidation(formName, true);
              nextTick(() => {
                setFormValidation(formName, "mobileNumber", true);
              });
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };

    onBeforeRouteLeave(async (to, from, next) => {
      console.log("before route leave");

      try {
        const leave = await checkFormChanged("userForm");

        if (leave === "save") {
          next(); // **Close modal first**
          await save("userForm"); // **Then save in background**
        } else if (!leave) {
          next(false); // Cancel navigation
        } else {
          next(); // Proceed
        }
      } catch (error) {
        console.error(error);
        next(false);
      }
    });



    onMounted(() => {
      setPageClassGlobal("global_profile_page");
      setFormRefs();
      console.log("jjjsjsjsj", userData.minRate);
     
      if (userRole == "locum") {
        if(userData.minRate){
        // formsData.userForm.minRate.value = userData.minRate;
        // checkFormValidation("userForm", true);
      }else{
        formsData.userForm.minRate = formsData.userForm.minRate ?? { value: null };
        formsData.userForm.weekendRate = formsData.userForm.weekendRate ?? { disabled: false };
        formsData.userForm.minRate.value = null;
        formsData.userForm.weekendRate.disabled = false;
        checkFormValidation("userForm", true);
      }
      }

     
      formsData.userForm.address.ref.update(
        formsData.userForm.address.value.text
      );

      if (userRole == "pharmacy") {
        formsData.userForm.billing_address.ref.update(
          formsData.userForm.billing_address.value
        );
      }

      console.log("checking validatoin");
      checkFormValidation("userForm", true);
      console.log("end validatoin");

      const scrollSection = $router.currentRoute.value.query.scroll;
      console.log("scroll", scrollSection);

      if (scrollSection) {
        setTimeout(() => {
          nextTick(() => {
            const sectionElement = document.getElementById(scrollSection);
            console.log("scroll out", sectionElement);
            if (sectionElement) {
              console.log("scroll out", sectionElement);
              sectionElement.scrollIntoView({ behavior: "smooth" });
            } else {
              console.log(`Element with ID '${scrollSection}' not found.`);
            }
          });
        }, 100);
      } else {
        console.log(
          "No scroll section specified in the route query parameters."
        );
      }

      console.log('formData:', formsData.userForm);

    });

    const {
      ["onFormMaskAccept"]: onFormMaskAccept,
      checkFormValidation,
      setFormValidation,
      copyFormResetValue,
      checkFormChanged,
      setFieldError,
      getFormValues, // eslint-disable-line no-unused-vars
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);
    const links = {
      changeProfile: () => {
        $router.push({
          name: "profile_edit",
        });
      },
      changeJobSeekerAdditional: () => {
        $router.push({
          name: "additional_profile_job_seeker",
        });
      },
      changePhoto: () => {
        $router.push({
          name: "profile_photo",
        });
      },
      goToCovidCert: () => {
        $router.push({
          name: "profile_covid_cert",
        });
      },
      goToPersonalCovidCert: () => {
        $router.push({
          name: "profile_personal_cert",
        });
      },
      goToPayment: () => {
        $router.push({
          name: "profile_payment",
        });
      },
      goToEmergencyContact: () => {
        $router.push({
          name: "emergency_contact",
        });
      },
      goToPayout: () => {
        $router.push({
          name: "profile_payout",
        });
      },
      goToAhpra: () => {
        $router.push({
          name: "profile_ahpra",
        });
      },
      notifications: () => {
        $router.push({
          name: "profile_notifications",
        });
      },
      gallery: () => {
        $router.push({
          name: "profile_gallery",
        });
      },
      goToGst: () => {
        $router.push({
          name: "profile_gst",
        });
      },
      travel: () => {
        $router.push({
          name: "profile_travel",
        });
      },

      languages: () => {
        $router.push({
          name: "profile_languages",
        });
      },
      softwareExperience:()=>{
        $router.push({
          name: "profile_software_experience",
        });
      },
      pharmacyExperience:()=>{
        $router.push({
          name: "profile_pharmacy_certification",
        });
      },
      experienceEdit:()=>{
        $router.push({
          name: "experience_edit",
        });
      },
      goToSupport: () => {
        $router.push({
          name: "support",
        });
      },
      goToAbout: () => {
        $router.push({
          name: "about",
        });
      },
      goToTermsAndConditions: () => {
        $router.push({
          name: "terms_and_conditions",
        });
      },
      goToPrivacyPolicy: () => {
        $router.push({
          name: "privacy_policy",
        });
      },
      changePassword: async () => {
        await $store.dispatch("PASSWORD_RESET");
        $router.push({
          name: "password_change",
        });
      },
      logout: () => {
        $store.dispatch("AUTH_LOGOUT");
      },
      preferences: () => {
        $router.push({
          name: "preferences",
        });
      },
      accountDeletionRequest: () => {
        $router.push({
          name: "account_deletion",
        });
      },
    };
    const selectedDispensingSoftware = ref(null);

    const handleSoftwareChange = () => {
      // const selectedOption = formsData.userForm.software.data.find(
      //   (item) => item.id === value
      // );
     
      // selectedDispensingSoftware.value = selectedOption.name;

      let softwares = $store.getters.GET_PHARMACY_SOFTWARE;
        let selectedSoftware = softwares.find(software => software.id === formsData.userForm.software.value);
        
        selectedDispensingSoftware.value = selectedSoftware.name;
        
        if (selectedSoftware.name === 'Other') {
          
          formsDataArray.userForm.software_other.resetValue = true;
            formsDataArray.userForm.software_other.validators = [{
                validator: (rule, formField, callback) => {
                    let value = formField.value;
                    let formName = formField.formName;
                    if (value != null && value != '') {
                        setFormValidation(formName, rule.field, true);
                        callback();
                    } else {
                      
                        setFormValidation(formName, rule.field, false);
                        callback(new Error('Please provide other software information'));
                        
                    }
                },
                trigger: 'change'
            }];
            checkFormValidation('userForm', true);
            formHooks(formsDataArray)
        } else {
        
            delete formsDataArray.userForm.software_other.resetValue;
            delete formsDataArray.userForm.software_other.validators;
            delete formsDataArray.userForm.software_other.valid;
            formsDataArray.userForm.software_other.value = null;
        }
        checkFormValidation('userForm', true);
     
      
    };

    const getSelectedSoftwareName = () => {
      let softwares = $store.getters.GET_PHARMACY_SOFTWARE;

      let selectedSoftware = softwares.find(software => software.id === formsData.userForm.software.value);
      
      return selectedSoftware?.name || '';
    }


    // Watch all form fields for changes and validate
    watch(
      () => [
        // Common fields for all roles
        formsData.userForm.address?.value?.text,
        formsData.userForm.mobileNumber?.value,
        formsData.userForm.email?.value,
        formsData.userForm.software_other?.value,

        // Locum & Agency fields
        formsData.userForm.firstName?.value,
        formsData.userForm.lastName?.value,
        formsData.userForm.preferredName?.value,

        // Pharmacy fields
        formsData.userForm.name?.value,
        formsData.userForm.shop_number?.value,

        // Billing fields (Pharmacy)
        formsData.userForm.billing_address?.value,
        formsData.userForm.billing_email?.value,
        formsData.userForm.billing_email2?.value,

        // Emergency contact (Locum)
        formsData.userForm.emergency_first_name?.value,
        formsData.userForm.emergency_last_name?.value,
        formsData.userForm.emergency_phone?.value,

        // Business & ABN (Multiple roles)
        formsData.userForm.businessName?.value,
        formsData.userForm.abn?.value,

        // AHPRA (Locum)
        formsData.userForm.ahpraNumber?.value,
        formsData.userForm.ahpraExpiryDate?.valueFormatted,

        // Additional contacts (Pharmacy)
        formsData.userForm.additionalName1?.value,
        formsData.userForm.additionalPhone1?.value,
        formsData.userForm.additionalName2?.value,
        formsData.userForm.additionalPhone2?.value,

        // Scripts (Pharmacy)
        formsData.userForm.scripts?.value,
        formsData.userForm.average_scripts_saturday_id?.value,
        formsData.userForm.average_scripts_sunday_id?.value,

        // Software & Services (Pharmacy)
        formsData.userForm.software?.value,
        formsData.userForm.services?.value,
        formsData.userForm.number_of_patients?.value,

        // Additional Pharmacy fields
        formsData.userForm.roboticDispensingSystem?.value,
        formsData.userForm.hasRoboticDispensingSystem_other?.value

        // Note: All fields are included regardless of role
        // Vue will handle undefined fields gracefully with optional chaining
      ],
      () => {
        console.log("watch trigger");
        checkFormValidation('userForm', true);
      },
      { deep: true }
    )

    return {
      setBillingAddress,
      formsData,
      onFormMaskAccept,
      checkFormValidation,
      goBack,
      save,
      userData,
      userRole,
      setAddressData,
      setAddress,
      onPhoneInput,
      onPhoneInput1,
      onPhoneInput2,
      onPhoneInput3,
      links,
      onNameCheckboxChange,
      isOphioidSelected,
      dateConvert,
      formLabel,
      closeOption,
      workEnvRef,
      dispensingSoftwareRef,
      sundayScriptsRef,
      saturdayScriptsRef,
      averageScriptsRef,
      isAustralia,
      countryArray,
      handleSoftwareChange,
      selectedDispensingSoftware,
      getSelectedSoftwareName,
      backPage,
      pharmacyAdditionalInfo,
      instance,
      getComponent
    };
  },
};
</script>
